export const GET_SNACKBAR = "GET_SNACKBAR";

export const updateSnackbar = (data) => {
  return {
    type: GET_SNACKBAR,
    payload: {
      snackbar: data,
    },
  };
};
